import {Component} from "@angular/core";
import {CompositeProductSearchModel} from "../composite-product-search.model";
import {CompositeProductEntityModel} from "../composite-product-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-composite-product-search-page",
    templateUrl: "./composite-product-search-page.component.html",

    providers: [
        provideSearchModel(CompositeProductSearchModel),
        provideEntityModel(CompositeProductEntityModel)
    ]
})

export class CompositeProductSearchPageComponent extends AbstractSearchPage {
    constructor(public model: CompositeProductSearchModel) {
        super();
    }
}
